import { equipmentList } from '../data/equipment';
import SectionHeading from '../components/ui/SectionHeading';
import AnimatedSection from '../components/ui/AnimatedSection';
import EquipmentCard from '../components/ui/EquipmentCard';
import CTABanner from '../components/sections/CTABanner';
import { Truck, Clock, DollarSign, Settings } from 'lucide-react';

const benefits = [
  {
    title: 'Project Efficiency',
    description:
      'Our own equipment ensures availability when you need it, eliminating rental delays and scheduling conflicts.',
    icon: Clock,
  },
  {
    title: 'Cost Control',
    description:
      'Direct equipment ownership translates to better pricing and more predictable project costs for our clients.',
    icon: DollarSign,
  },
  {
    title: 'Well-Maintained Fleet',
    description:
      'Regular maintenance and inspections ensure our equipment operates safely and reliably on every project.',
    icon: Settings,
  },
  {
    title: 'Versatile Capabilities',
    description:
      'A diverse equipment fleet allows us to handle various project requirements without external dependencies.',
    icon: Truck,
  },
];

export default function Equipment() {
  return (
    <>
      <section className="pt-32 pb-16 bg-gradient-to-b from-charcoal-900 to-charcoal-800">
        <div className="container-custom">
          <AnimatedSection>
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="heading-1 text-white mb-6">
                Our Equipment
              </h1>
              <p className="text-xl md:text-2xl font-semibold text-charcoal-200 mb-4">
                Modern Equipment for Efficient Execution
              </p>
             
            </div>
          </AnimatedSection>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <AnimatedSection>
            <SectionHeading
              subtitle="Why It Matters"
              title="Equipment Ownership Advantage"
              description="Owning our equipment gives us control over project timelines and costs, directly benefiting our clients."
            />
          </AnimatedSection>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            {benefits.map((benefit, index) => (
              <AnimatedSection key={index} delay={index * 0.1}>
                <div className="p-6 bg-charcoal-50 rounded-2xl h-full">
                  <div className="p-3 bg-primary-100 rounded-xl w-fit mb-4">
                    <benefit.icon className="w-6 h-6 text-primary-600" />
                  </div>
                  <h3 className="font-semibold text-lg text-charcoal-900 mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-charcoal-600 text-sm leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-charcoal-50">
        <div className="container-custom">
          <AnimatedSection>
            <SectionHeading
              subtitle="Our Fleet"
              title="Equipment & Machinery"
              description="From earthmoving to elevated work platforms, our equipment fleet supports all aspects of construction operations."
            />
          </AnimatedSection>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
            {equipmentList.map((equipment, index) => (
              <EquipmentCard
                key={equipment.name}
                name={equipment.name}
                description={equipment.description}
                capabilities={equipment.capabilities}
                icon={equipment.icon}
                image={equipment.image}
                index={index}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <AnimatedSection>
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="heading-2 text-charcoal-900 mb-6">
                Equipment Rental Available
              </h2>
              <p className="text-body mb-8">
                In addition to using our equipment for project execution, we
                also offer prop rental and scaffolding services for contractors
                and construction professionals who need reliable equipment for
                their own projects.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <span className="px-6 py-3 bg-primary-50 text-primary-700 font-medium rounded-full">
                  Scaffolding Rental
                </span>
                <span className="px-6 py-3 bg-primary-50 text-primary-700 font-medium rounded-full">
                  Prop Rental
                </span>
                <span className="px-6 py-3 bg-primary-50 text-primary-700 font-medium rounded-full">
                  Formwork Support
                </span>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
